import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconCircle: React.FC<IconProps> = ({ color = 'var(--color-accent-1)' }): JSX.Element => (
    <div className="icon-block">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="7.29447" cy="7.94044" rx="7.29447" ry="6.9651" fill={color} />
        </svg>
    </div>
);

export default IconCircle;